import actions from '../../../../sharedmodules/actions-list';

export const resetPinSearchData = () => ({
    type: actions.RESET_PIN_SEARCH_DATA,
});
